<template>
    <div class="contacts" :title="model.id">
        <input type="text" v-model="model.url" class="hg-input" :pattern="get_pattern(model)"/>
        <span class="icon">
            <font-awesome-icon :icon="get_icon(model)" size="lg"/>
        </span>
    </div>
</template>
<script>
export default {
    props:["model"],
    methods: {
        get_icon: function(c){
            var t = this.$hisport.default_contacts.find(function(x){ return c.id == x.id; });
            return t && t.icon;
        },
        get_pattern: function(c){
            var t = this.$hisport.default_contacts.find(function(x){ return c.id == x.id; });
            return t && t.pattern;
        }
    }
}
</script>
<style scoped>
.contacts{
    position:relative;
    margin-bottom:3px;
}
.contacts .icon{
    width:40px;
    height:36px;
    left:0px;
    background: #eee;
    position: absolute;
    margin:2px;
    border-radius:.5em 0 0 .5em;
    padding: 8px;
    text-align:center;
    color:#aaa;
    border-right: 1px solid #aaa;
    cursor:help;
}
.contacts input{
    padding-left: 50px;
}
</style>